import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { NotificationBellComponent } from "@modules/notifications/features/notification-bell/notification-bell.component";
import { NotificationsBoardModule } from "@modules/notifications/features/notifications-board/notifications-board.module";
import { NotificationsBoardComponent } from "@modules/notifications/features/notifications-board/notifications-board.component";
import { OverlayModule } from "@angular/cdk/overlay";

@NgModule({
	declarations: [NotificationBellComponent, NotificationsBoardComponent],
	exports: [NotificationBellComponent],
	imports: [CoreModule, NotificationsBoardModule, OverlayModule]
})
export class NotificationBellModule {}
